import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import Swal from 'sweetalert2';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private authService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        console.log(err)
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            // "Token is Invalid." fires whenever txt_token no longer matches
            // what the server has on file -- the same-user-logged-in-elsewhere
            // case (see JwtMiddleware/LoginController::update_token(), which
            // unconditionally overwrites txt_token on every login). Give that
            // specific case a message that explains why, instead of the raw
            // backend string.
            const loggedInElsewhere = err.error?.error === 'Token is Invalid.';
            Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: loggedInElsewhere
                ? 'You have been logged out because your account was signed in on another device or browser.'
                : err.error.error,
              timer: loggedInElsewhere ? 2500 : 1500,
            });
            setTimeout(() => {
              this.authService.doLogout();
            }, 1500); // Optional: Delay logout to match Swal timer
            return throwError(() => new Error('Unauthorized')); // Return an Observable
          } else {
            const error = err.error.message || err.statusText;
            return throwError(() => new Error(error)); // Consistent return
          }
        }
        // Fallback for non-HttpErrorResponse errors
        return throwError(() => err); // Ensure all paths return
      })
    );
  }
}
